import { WidgetFeature } from 'enums/WidgetFeature';
import { FeaturesMap } from 'interfaces/FeatureMap';
import { WidgetFeatures } from 'interfaces/WidgetFeatures';

export const enum FeatureActionType {
    SetFeaturesActive = 'FEATURES/SET_FEATURES_ACTIVE',
    SetFeatureActive = 'FEATURES/SET_FEATURE_ACTIVE',
}

export type SetFeaturesActiveAction = ReturnType<typeof setFeaturesActive>;
export const setFeaturesActive = (features: WidgetFeatures) => ({
    type: FeatureActionType.SetFeaturesActive,
    payload: features as FeaturesMap,
});

export type SetFeatureActiveAction = ReturnType<typeof setFeatureActive>;
export const setFeatureActive = (feature: WidgetFeature, enabled: boolean) => ({
    type: FeatureActionType.SetFeatureActive,
    payload: [feature, enabled] as const,
});
